import styled from "styled-components"

import Subtitle from "./Subtitle"

const SubtitleH3 = styled.p`
  ${Subtitle}

  font-size: 18px;
`

export default SubtitleH3
